// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCx0o4wQ42OrT0zX0JvQfs3Ia2PGreuXRs",
  authDomain: "vpjc-website-2e8bc.firebaseapp.com",
  projectId: "vpjc-website-2e8bc",
  storageBucket: "vpjc-website-2e8bc.appspot.com",  // ✅ FIXED
  messagingSenderId: "805872224468",
  appId: "1:805872224468:web:6aab83b44b2824ab7b5341",
  measurementId: "G-7F24WSM5T0"
};


// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Export initialized instances
export const auth = getAuth(app);
export const db = getFirestore(app);
